<template>
  <v-container style="width:100% !important;">
    <v-layout row wrap>
      <v-flex xs12 sm6 class="ml-4 py-2">
        <v-btn
          :outline="currentView == 'payment' ? false : true"
          color="primary"
          @click="changeView('payment')"
          small
        >
          {{ $t('Payment Method') }}
        </v-btn>
        <v-btn
          :outline="currentView == 'payment-setting' ? false : true"
          color="primary"
          @click="changeView('payment-setting')"
          small
        >
          {{ $t('more_setting') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <component :is="currentView"></component>
  </v-container>
</template>

<script>
import Payment from './Payment.vue'
import paymentSetting from './paymentSetting.vue'
export default {
  computed: {},
  data: function() {
    return {
      currentView: 'payment'
    }
  },
  created() {},
  mounted() {
    const vm = this
    let localView = localStorage.getItem('currentView')
    if (localView === 'payment') {
      vm.currentView = 'payment'
    } else if (localView === 'payment-setting') {
      vm.currentView = 'payment-setting'
    } else {
      vm.currentView = 'payment'
    }
  },
  components: {
    Payment,
    paymentSetting
  },
  methods: {
    changeView(view) {
      const vm = this
      let setView = localStorage.setItem('currentView', view)
      vm.currentView = view
    }
  },
  watch: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/mainPayment.vue